import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { BaseDto } from "@models/base/baseDto.model";
import { CreateRequestBaseComplete } from "@models/base/createRequestBaseComplete.model";
import { CreateResponseBase } from "@models/base/createResponseBase.model";
import { DtoBaseComplete } from "@models/base/dtoBaseComplete.model";
import { UpdateRequestBaseComplete } from "@models/base/updateRequestBaseComplete.model";
import { Observable, of } from "rxjs";
import { isFalsy } from "utility-types";


@Injectable({
  providedIn: 'root'
})
export class CrudGenericoService {
  private http = inject(HttpClient);


  getAll(entidad: string): Observable<DtoBaseComplete[]> {
    return this.http.get<DtoBaseComplete[]>("/api/" + entidad + "/GetAll");
  }

  create(entidad: string, item: CreateRequestBaseComplete): Observable<CreateResponseBase> {
    return this.http.post<CreateResponseBase>("/api/" + entidad + "/Create", item);
  }

  update(entidad: string, item: UpdateRequestBaseComplete): Observable<unknown> {
    return this.http.put<unknown>("/api/" + entidad + "/Update", item);
  }

  getById(entidad: string, id: number): Observable<DtoBaseComplete> {
    return this.http.get<DtoBaseComplete>("/api/" + entidad + "/GetById?id=" + id);
  }

  delete(entidad: string, id: number): Observable<unknown> {
    if (!isFalsy(id))
      return this.http.delete<unknown>("/api/" + entidad + "/Delete?id=" + id);
    else
      return of(null)
  }

}
